export default __webpack_public_path__ + "static/og-b7e541315a7d7e3653c164f9f073f134.png";